import { Component } from '@angular/core';
import { BasePluginMenuComponent } from './base.menu';

@Component({
    templateUrl: './edit-fileandsuggestions.menu.html',
    standalone: false
})
export class EditFileAndSuggestionMenuComponent extends BasePluginMenuComponent {}
